var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.636 12.012"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.707 6.267l4.331 4.331L14.929.707",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNS42MzYiIGhlaWdodD0iMTIuMDEyIiB2aWV3Qm94PSIwIDAgMTUuNjM2IDEyLjAxMiI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6bm9uZTtzdHJva2U6Y3VycmVudENvbG9yO3N0cm9rZS13aWR0aDoycHg7fTwvc3R5bGU+PC9kZWZzPjxwYXRoIGNsYXNzPSJhIiBkPSJNNjU3Mi42MzcsNjU3Mi45MTlsNC4zMzEsNC4zMzEsOS44OTEtOS44OTEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02NTcxLjkzIC02NTY2LjY1MikiLz48L3N2Zz4=";
export { SvgCheckmark as ReactComponent };